export default __webpack_public_path__ + "static/media/logo_horizontal.c170a1ab.png";